/* eslint-disable */
import cn from 'classnames'
import React from 'react'
import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  .input-component {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    border-bottom: 1px solid #d8dde6;

    label {
      color: #54698d;
      font-weight: 400;
      font-size: 14px;
      word-wrap: break-word;

      span {
        content: "*";
        color: #d0021b;
        padding-left: 8px;
      }
    }

    .input-wrapper {
      position: relative;
      width: 100%;

      .icSearch{
        position: absolute;
        right: 0;
        top: 4px;
        cursor: pointer;
        padding: 10px;
      }

      .icLocked {
        &:hover {
          cursor: not-allowed;
        }
      }

      i {
        position: absolute;
        right: 0;
        top: 2px;
        cursor: pointer;
        padding: 10px;
      }
    }

    input {
      box-sizing: border-box;
      box-shadow: none;
      outline: 0;
      border: 0;
      font-size: 15px;
      font-weight: 500;
      color: #6b6b6b;
      background-color: transparent;
      height: 38px;
      width: 100%;

      &:disabled {
        background-color: #ffffff;
      }

      &:disabled:hover {
        cursor: not-allowed;
      }
    }

    input:focus {
      background-color: #F7F7F7;
      border-bottom: 1px solid #009ade;
      color: #7d7d84;
    }

    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: #7d7d84;
    }
    &::-moz-placeholder { /* Firefox 19+ */
      color: #7d7d84;
    }
    &:-ms-input-placeholder { /* IE 10+ */
      color: #7d7d84;
    }
    &:-moz-placeholder { /* Firefox 18- */
      color: #7d7d84;
    }

    .input-error{
      background-color: #F7F7F7;
      border-bottom: 1px solid red;
      color: #7d7d84;
    }
  }
`

const TextInput = props => {
  const {
    label,
    value,
    onChange,
    placeholder,
    required,
    icon,
    isFullWidth,
    type,
    isError,
    onFocus,
    onSubmit,
    onBlur,
    disabled,
    handleOnClickIcon,
    isLockedIcon,
    className,
    inputRef,
    ...rest
  } = props

  return (
    <React.Fragment>
      <GlobalStyle />
      <div
        className={cn(className, 'input-component', {
          'w-haft': isFullWidth,
        })}
      >
        {!label ? null : (
          // biome-ignore lint/a11y/noLabelWithoutControl: TODO
          <label>
            {label} {required && <span>*</span>}
          </label>
        )}
        {icon ? (
          <div className="input-wrapper">
            <input
              disabled={disabled}
              onChange={onChange}
              type={type}
              ref={inputRef}
              placeholder={placeholder}
              value={value}
              {...rest}
            />
            {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
            {/** biome-ignore lint/a11y/useKeyWithClickEvents: TODO */}
            <div
              className={cn('icSearch', isLockedIcon ? 'icLocked' : null)}
              onClick={() => !isLockedIcon && handleOnClickIcon()}
            >
              {icon}
            </div>
          </div>
        ) : (
          <input
            className={cn({ 'input-error': isError })}
            disabled={disabled}
            value={value}
            onBlur={onBlur}
            onSubmit={onSubmit}
            ref={inputRef}
            onFocus={onFocus}
            onChange={onChange}
            type={type}
            placeholder={placeholder}
            {...rest}
          />
        )}
      </div>
    </React.Fragment>
  )
}

TextInput.defaultProps = {
  label: '',
  placeholder: '',
  // value: '', // Support uncontroller component
  required: false,
  type: 'text',
  isFullWidth: false,
  isLockedIcon: false,
  isError: false,
  disabled: false,
  className: '',
  onChange: f => f,
  onFocus: f => f,
  onSubmit: f => f,
  onBlur: f => f,
  handleOnClickIcon: () => 0,
}

export default TextInput
